// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__c_sfo","summary":"CartItem_summary__ViuK4","price":"CartItem_price__1rdjI","amount":"CartItem_amount__38b3H","actions":"CartItem_actions__32enD"};